import React, { useEffect, useState } from "react";
import './FeatureSelector.css'; 

export default function FeatureSelector({selectedFeatures, onChange}) {
  const [features, setFeatures] = useState([]);
   const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    // Fetch features from the API 
    const fetchFeatures = async () => {
      try {
        const response = await fetch(`${global.API_STRIPEAPI_URL}getAllFeaturesForSelection`);
        const data = await response.json();
        setFeatures(data.features || []);
      } catch (error) {
        console.error("Error fetching features:", error);
      }
    };

    fetchFeatures();
  }, []);

  useEffect(() => {
  if (features.length === 0) return;

  setFeatures((prevFeatures) =>
    prevFeatures.map((feature) => {
      const matched = selectedFeatures.find(
        (selected) => selected.id === feature.id
      );
      return matched
        ? { ...feature, is_available: matched.is_available }
        : { ...feature, is_available: false };
    })
  );
}, [selectedFeatures, features.length]);

  

  const toggleFeature = (id) => {
  setFeatures((prevFeatures) => {
    const updatedFeatures = prevFeatures.map((feature) =>
      feature.id === id
        ? { ...feature, is_available: !feature.is_available }
        : feature
    );
    onChange(updatedFeatures); // Call with updated list
    return updatedFeatures;    // Return so state is updated
  });
};

const toggleSelectAll = () => {
    setFeatures((prevFeatures) => {
      const newValue = !selectAll;
      const updatedFeatures = prevFeatures.map((feature) => ({
        ...feature,
        is_available: newValue,
      }));
      setSelectAll(newValue);
      onChange(updatedFeatures);
      return updatedFeatures;
    });
  };


  return (
    <div className="feature-selector">
  <h3 className="feature-title">✨ Select Features</h3>
  <div className="select-all">
        <label className="feature-label">
          <input
            type="checkbox"
            checked={selectAll}
            onChange={toggleSelectAll}
            className="feature-checkbox"
          />
          <span className="feature-name">Select All</span>
        </label>
      </div>
  <ul className="feature-list">
    {features.map((feature) => (
      <li key={feature.id} className="feature-item">
        <label className="feature-label">
          <input
            type="checkbox"
            checked={feature.is_available}
            onChange={() => toggleFeature(feature.id)}
            className="feature-checkbox"
          />
          <span className="feature-name">{feature.name}</span>
        </label>
      </li>
    ))}
  </ul>
</div>
  );
}